import { Info } from './src/Info'
export { Info }
export default Info



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Info/index.ts